module.exports = __webpack_public_path__ + "img/th_53-20.fede36c1.jpg";